import * as React from 'react';
import translate from '../../../../locale/translate';

import { getDisplayValue, formatDate } from '../../util/StringUtil';
import ISettings from './ISettings';

import { MAV } from '../../../../interfaces';

interface IProps {
    title: string,
    events: MAV.IEvent[],
    settings: ISettings,
}

const AVAILABLE_COLS = [
    'SystemName',
    'MalwareCategory',
    'MalwareName',
    'Module',
    'Timestamp',
];

const COL_TITLES = {
    SystemName: translate.gettext("Name"),
    Timestamp: translate.gettext("Event timestamp"),
    MalwareCategory: translate.gettext("Thread category"),
    MalwareName: translate.gettext("Thread name"),
    Module: translate.gettext("Thread detection module"),
};

const HEADER_CLASSES = {
    SystemName: 'small col-xs-2',
    Timestamp: 'small col-xs-2 text-right',
    MalwareCategory: 'small col-xs-2',
    MalwareName: 'small col-xs-2',
    Module: 'small col-xs-2',
};

const COL_CLASSES = {
    SystemName: 'small',
    Timestamp: 'small text-right',
    MalwareCategory: 'small',
    MalwareName: 'small',
    Module: 'small',
};

export default class EventTable extends React.Component<IProps, {}> {
    static propTypes = {
        title: React.PropTypes.string.isRequired,
        events: React.PropTypes.array,
        settings: React.PropTypes.object.isRequired,
    };

    renderColumnHead(name: string, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            return (
                <th key={name} className={HEADER_CLASSES[name]}>{COL_TITLES[name]}</th>
            );
        }

        return;
    }

    renderColumn(name: string, event, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            let value = event[name];

            if (name === 'Timestamp') {
                value = formatDate(value, 'L LT');
            }

            return (
                <td key={name} className={COL_CLASSES[name]}>{value}</td>
            );
        }

        return;
    }

    renderAction(event: MAV.IEvent) {
        if (event.File) {
            return (<span>{event.Action}<br />{event.File}</span>);
        }

        return event.Action;
    }

    renderRow(event: MAV.IEvent, idx: number, settings: ISettings) {
        return (
            <tr key={event.Id}>
                <td className="small">{this.renderAction(event)}</td>
                {AVAILABLE_COLS.map(name => {
                    return this.renderColumn(name, event, settings);
                })}
            </tr>
        );
    }

    render() {
        let { events } = this.props;
        const { title, settings } = this.props;

        const key = `events-${title}`;
        const headers = AVAILABLE_COLS.map(name => {
            return this.renderColumnHead(name, settings);
        }).filter(header => !!header);
        const colCount = headers.length + 1;

        let rows;

        if (!events || !events.length) {
            let key = `no-events-${title}`;
            rows = [
                <tr key={key}>
                    <td className="muted small" colSpan={colCount}>{translate.gettext("No events occured")}</td>
                </tr>
            ];
        } else {
            rows = events.map((event, idx) => {
                return this.renderRow(event, idx, settings);
            });
        }

        return (
            <table key={key} className="table">
                <thead>
                    <tr>
                        <th className="col-xs-4">{title}</th>
                        {headers}
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/eventCommon/EventTable.tsx